import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

export interface UserProfile {
  id: string;
  email: string;
  full_name: string | null;
  first_name: string | null;
  last_name: string | null;
  phone: string | null;
  company: string | null;
  is_admin: boolean;
  created_at: string;
  updated_at: string;
}

// Récupérer tous les profils utilisateurs (admin only)
export function useUsersAdmin() {
  const { user } = useAuth();

  return useQuery({
    queryKey: ['admin', 'users'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('profiles')
        .select('*')
        .order('created_at', { ascending: false });

      if (error) throw error;
      return data as UserProfile[];
    },
    enabled: !!user,
  });
}

// Statistiques utilisateurs
export function useUsersStats() {
  const { user } = useAuth();

  return useQuery({
    queryKey: ['admin', 'users', 'stats'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('profiles')
        .select('*');

      if (error) throw error;

      const users = data as UserProfile[];
      return {
        total: users.length,
        admins: users.filter((u) => u.is_admin).length,
        regular: users.filter((u) => !u.is_admin).length,
      };
    },
    enabled: !!user,
  });
}
